import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatOptionModule } from '@angular/material/core';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatTooltipModule } from '@angular/material/tooltip';
import { SatPopoverModule } from '@ncstate/sat-popover';
import { SgCoreModule } from '@sg/ui-kit';
import {
  SgBorrowerEntityInputComponent,
  SgBorrowerEntitySelectComponent,
  SgBorrowerInputComponent,
  SgBorrowRateRequestButtonComponent,
} from '../components';
import { SgBorrowerTransactionDateSelectComponent } from '../components/borrower-transaction-date-select/borrower-transaction-date-select.component';
import { SgErrorMessagePipe } from '../pipes';
import { SgActionCellComponent } from './action-cell/action-cell.component';
import { SgCollateralTypeCellComponent } from './collateral-type-cell/collateral-type-cell.component';
import { SgLendingRateCellComponent } from './lending-rate-cell/lending-rate-cell.component';
import { SgSettlementDateCellComponent } from './settlement-date-cell/settlement-date-cell.component';
import { SgUnitsCellComponent } from './units-cell/units-cell.component';
import { SgValueCellComponent } from './value-cell/value-cell.component';
import { NgxMaskPipe, NgxMaskDirective, provideNgxMask } from 'ngx-mask';

@NgModule({
  declarations: [
    SgActionCellComponent,
    SgValueCellComponent,
    SgLendingRateCellComponent,
    SgUnitsCellComponent,
    SgBorrowRateRequestButtonComponent,
    SgBorrowerInputComponent,
    SgBorrowerTransactionDateSelectComponent,
    SgErrorMessagePipe,
    SgSettlementDateCellComponent,
    SgCollateralTypeCellComponent,
    SgBorrowerEntitySelectComponent,
    SgBorrowerEntityInputComponent,
  ],
  imports: [
    CommonModule,
    MatIconModule,
    MatButtonModule,
    MatFormFieldModule,
    MatInputModule,
    MatTooltipModule,
    MatSelectModule,
    ReactiveFormsModule,
    SatPopoverModule,
    SgCoreModule,
    MatOptionModule,
    NgxMaskPipe,
    NgxMaskDirective,
  ],
  providers: [provideNgxMask()],
  exports: [
    SgActionCellComponent,
    SgValueCellComponent,
    SgLendingRateCellComponent,
    SgUnitsCellComponent,
    SgBorrowRateRequestButtonComponent,
    SgBorrowerInputComponent,
    SgBorrowerTransactionDateSelectComponent,
    SgErrorMessagePipe,
    SgSettlementDateCellComponent,
    SgCollateralTypeCellComponent,
    SgBorrowerEntitySelectComponent,
    SgBorrowerEntityInputComponent,
    MatOptionModule,
    MatSelectModule,
  ],
})
export class SgLocateMatchCellsModule {}
